import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import CancelModel from "./CancelModel";

class MyBadgeRequestList extends Component {
    state = {
        cancel: false,
        item: {}
    };
    /* cancel */
    cancel = () => {
        return this.props.cancel(this.props.item.id);
    };

    toggleCancel = () => {
        this.setState({ cancel: this.state.cancel === true ? false : true });
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>{this.props.item.badge.name}</td>
                    <td className="large">
                        {this.props.item.badge.description}
                    </td>
                    <td>{this.props.item.badge.paid}</td>
                    <td>
                        <img
                            style={{ width: 32 }}
                            src={this.props.item.badge.image}
                            alt={this.props.item.badge.name}
                        ></img>
                    </td>
                    <td>
                        {this.props.item.auto === "true" ? (
                            "Auto-Earned"
                        ) : (
                            <button
                                onClick={this.toggleCancel}
                                type="button"
                                className="btn btn-sm  btn-danger mr-2 p-1"
                            >
                                Cancel
                            </button>
                        )}
                    </td>
                </tr>
                {this.state.cancel === true ? (
                    <CancelModel
                        cancel={this.cancel}
                        hideCancel={this.toggleCancel}
                    ></CancelModel>
                ) : null}
            </Fragment>
        );
    }
}
MyBadgeRequestList.contextType = AppContext;
export default MyBadgeRequestList;



// WEBPACK FOOTER //
// ./src/components/writer/writerBadges/MyBadgeRequestList.js